/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Dispatch, SetStateAction, createContext } from 'react'

interface IDatasetContext {
  attributeNames: string[]
  selectedAttributes: string[]
  setSelectedAttributes: (args: string[]) => void
  // maxBondlength: string
  selectedBondlength: number
  setSelectedBondlength: (args: number) => void
  // bond angle
  selectedBondAngle: string
  setSelectedBondAngle: (args: string) => void
  // basis
  selectedBasis: string
  setSelectedBasis: (args: string) => void
  // periodicities: string[]
  selectedPeriodicity: string
  setSelectedPeriodicity: (args: string) => void
  // lattices: string[]
  selectedLattice: string
  setSelectedLattice: (args: string) => void
  // layouts: string[]
  selectedLayout: string
  setSelectedLayout: (args: string) => void
  selectedConfiguration: string
  selectedNumSpinOrbitals: string
  setSelectedNumSpinOrbitals: (args: string) => void
  setSelectedConfiguration: (args: string) => void
  parameterDefaults: {
    options: { [key: string]: string[] }
    selection: { [key: string]: string }
  }
  setParameterDefaults: Dispatch<
    SetStateAction<{
      options: { [key: string]: string[] }
      selection: { [key: string]: string }
    }>
  >
  pageSlug: string
  parameterOptions: {
    options: { [key: string]: string[] }
    selection: { [key: string]: string }
  }
  setParameterOptions: Dispatch<
    SetStateAction<{
      options: { [key: string]: string[] }
      selection: { [key: string]: string }
    }>
  >
  downloadName: string
  modifiedAt: string
}

export const DatasetContext = createContext<IDatasetContext>({
  attributeNames: [],
  selectedAttributes: [],
  setSelectedAttributes: (_args: string[]) => {},
  selectedBondlength: 0.0,
  setSelectedBondlength: (_args: number) => {},
  selectedBondAngle: '',
  setSelectedBondAngle: (_args: string) => {},
  selectedBasis: '',
  setSelectedBasis: (_args: string) => {},
  selectedPeriodicity: '',
  setSelectedPeriodicity: (_args: string) => {},
  selectedLattice: '',
  setSelectedLattice: (_args: string) => {},
  selectedLayout: '',
  setSelectedLayout: (_args: string) => {},
  selectedNumSpinOrbitals: '',
  setSelectedNumSpinOrbitals: (_args: string) => {},
  selectedConfiguration: '',
  setSelectedConfiguration: (_args: string) => {},
  parameterDefaults: {
    options: {},
    selection: {},
  },
  setParameterDefaults: () => null,
  pageSlug: '',
  parameterOptions: {
    options: {},
    selection: {},
  },
  setParameterOptions: () => null,
  downloadName: '',
  modifiedAt: '',
})
